export default __webpack_public_path__ + "static/media/increasing.2883bc1e.svg";